import React from 'react';
import { SpaceBetween, StyledContainer } from '../../components/container/styles';
import { TextLarge } from '../../components/text';
import { CardTheme } from '../../components/card';
import { ResponsivePageLayout } from '../../components/page/responsive-layout/ResponsivePageLayout';
import { Icon } from '../../resources';
import { useGetReportCampaign } from './hooks/useGetReportCampaign';
import { ContainerButton } from '../../styles/global-style';
import ButtonExcelEmbedded from '../../components/report-excel/ButtonExcelEmbedded';

export const ReportCampaign = () => {
  const {
    formSearchObj,
    formSearch,
    columnData,
    campaignData,
    campaignDataFull,
    loadingFull,
    loading,
    onSearchByField,
    searchType,
    formatDataForExcel,
  } = useGetReportCampaign();

  return (
    <StyledContainer>
      <TextLarge text="รายงานการใช้สิทธิ์ Campaign" />
      <CardTheme>
        <ResponsivePageLayout
          searchLayout={{
            title: 'ค้นหารายงาน Campaign',
            icon: <Icon.todo />,
            formSearch,
            useFormParam: formSearchObj,
            onSearch: formSearchObj.handleSubmit(onSearchByField),
            onClear: formSearchObj.reset,
          }}
          tableLayout={{
            columns: columnData || [],
            dataSource: searchType === 'date' ? campaignData : campaignDataFull || [],
            loading: searchType === 'date' ? loading : loadingFull,
            rowKey: 'campaignTranId',
            hasPagination: true,
            extraContent: (
              <SpaceBetween>
                <ContainerButton right>
                  <ButtonExcelEmbedded
                    title="Export"
                    filename="รายงานการใช้สิทธิ์ Campaign"
                    header={[
                      { title: 'ลำดับ', dataIndex: 'ลำดับ' },
                      { title: 'Partner', dataIndex: 'Partner' },
                      { title: 'ชื่อ Campaign', dataIndex: 'ชื่อ Campaign' },
                      { title: 'รหัสคูปอง', dataIndex: 'รหัสคูปอง' },
                      { title: 'สถานะ', dataIndex: 'สถานะ' },
                      { title: 'ชื่อ-นามสกุล', dataIndex: 'ชื่อ-นามสกุล' },
                      { title: 'เบอร์โทร', dataIndex: 'เบอร์โทร' },
                      { title: 'รหัสลงทะเบียน', dataIndex: 'รหัสลงทะเบียน' },
                      { title: 'รหัส Warranty', dataIndex: 'รหัส Warranty' },
                      { title: 'วันที่เริ่มต้น', dataIndex: 'วันที่เริ่มต้น' },
                      { title: 'วันที่หมดอายุ', dataIndex: 'วันที่หมดอายุ' },
                      { title: 'วันที่ใช้สิทธิ์', dataIndex: 'วันที่ใช้สิทธิ์' },
                      { title: 'Description', dataIndex: 'Description' },
                    ]}
                    data={formatDataForExcel(
                      searchType === 'date' ? campaignData : campaignDataFull || [],
                    )}
                  />
                </ContainerButton>
              </SpaceBetween>
            ),
          }}
        />
      </CardTheme>
    </StyledContainer>
  );
};
